module.exports = __webpack_public_path__ + "static/media/04-1.03cb4ea7.webp";